import { useLocalstackStatus } from '@localstack/services';
import { LocalStackEdition } from '@localstack/types';

import { Box } from '@mui/material';
import { ReactElement } from 'react';

import { LicenseAlert } from './LicenseAlert';
import { NotRunningAlert } from './NotRunningAlert';

type StatusAlertProps = {
  endpoint?: string;
};
export const StatusAlert = ({ endpoint }: StatusAlertProps): ReactElement => {
  const { running, edition } = useLocalstackStatus({ endpoint });
  const isOSS = edition == LocalStackEdition.COMMUNITY;

  return (
    <Box marginBottom={3}>
      {isOSS && running && <LicenseAlert />}
      {!running && <NotRunningAlert />}
    </Box>
  );
};
